import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemUserGetSchema} from '../../../../api/DBSchema/SystemUser';
import {useBoolean} from '../../../../utils/hooks';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCButton from '../../../../components/Simple/SMCButton';
import SetServiceDomainModal from '../../../PopupPages/SetServiceDomainModal';

const pageSchema = SystemUserGetSchema.pages.serviceDomains;
const pageId = pageSchema.pageId;

function SystemUserDomains({
    systemUserObject,
    setSystemUserData
}) {
    const { t } = useTranslation();

    const pageData = systemUserObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSystemUserData([pageId, paramName], value);
    }, [setSystemUserData]);

    const serviceDomainList = pageData[pageSchema.serviceDomainList];
    const serviceDomainTableData = serviceDomainList ? serviceDomainList.map(domainName => ({ name: domainName })) : serviceDomainList;

    const [isAddServiceDomainModalOpen, openAddServiceDomainModal, closeAddServiceDomainModal] = useBoolean(false);

    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMC_MENU_GLOBAL_PORTALS')}</SMCLabel>
            <SMCTable
                columns={[
                    { id: 'count', header: '#',           width: 32,                    align: 'center', Cell: ({index}) => index+1 },
                    { id: 'name',  header: t('SMP.NAME'), width: 200, accessor: 'name', align: 'center'                             }
                ]}
                content={serviceDomainTableData}
                hasCheckboxColumn={false}
            />
            <SMCButton style={{ margin: '7px 0' }} onClick={openAddServiceDomainModal}>{t('SMC_GEN_EDIT')}</SMCButton>
            {/* Popup windows */}
            <SetServiceDomainModal
                isOpen={isAddServiceDomainModalOpen}
                onRequestClose={closeAddServiceDomainModal}
                defaultSelected={serviceDomainList}
                onSuccess={domainList => {
                    setPageValue(pageSchema.serviceDomainList, domainList);
                    closeAddServiceDomainModal();
                }}
            />
        </EditorLayout>
    )
}

export default SystemUserDomains;